import {Button} from "../../../../index";
import React from "react";
import FinaliseConfirm from "./FinaliseConfirm";
import {useViewerStore} from "../../../../../store/store";
import {RoofMesh} from "../../../../../@types/types";
import {Table} from "antd";


interface RoofPitchData {
    key: number;
    roofId: number;
    originalPitch: number;
    overridePitch: number;
}

interface PitchOverrideInfoTableProps {
    roofPitchData: RoofPitchData[];
}

const PitchOverrideInfoTable: React.FC<PitchOverrideInfoTableProps> = ({ roofPitchData }) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);


    const closeModal = () => {
        sceneViewer.viewerAlert({show: false})
    }

    const tableColumns = [
        {
            title: 'Roof No',
            dataIndex: 'roofId',
            key: 'roofId',
        },
        {
            title: 'Original Pitch',
            dataIndex: 'originalPitch',
            key: 'originalPitch',
        },
        {
            title: 'Override Pitch',
            dataIndex: 'overridePitch',
            key: 'overridePitch',
        }

    ];


    return (
        <>
            <p>Following roofs have pitch overrides applied:
                <br/>
                <br/>
                <Table columns={tableColumns} dataSource={roofPitchData} bordered={true} pagination={false} />
            </p>
            <br/>
            <div className={"modal-bottom-action-button-container"}>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={closeModal}
                >
                    Close
                </Button>

            </div>
        </>
    )
}

export default PitchOverrideInfoTable;